import AuthService from './authService';
import OutsourcedIOBLineItemDetailItem from '../Domain/OutsourcedIOBLineItemDetailItem';
import SearchParams from '../Elements/SearchParams';
import OutsourcedIOBLineItemDetailSearchParams from '../Contents/OutsourcedInvoicing/OutsourcedIOBLineItemDetail/OutsourcedIOBLineItemDetailSearchParams';

export default class OutsourcedIOBLineItemDetailService {
  static GetList(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(
      searchItem,
      OutsourcedIOBLineItemDetailSearchParams,
      orderById,
      orderDir,
      pageNumber,
      numberOfElements
    );

    const url = `/api/OutsourcedIOBLineItemDetail/GetList/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItem(items) {
    if (items === null) return [];
    return items.map((item) => new OutsourcedIOBLineItemDetailItem(item));
  }

  static Upsert(editedItem) {
    editedItem.SurveyId = editedItem.SurveyId?.split('//')[0] ?? null;
    editedItem.TpSurveyId = editedItem.TpSurveyId?.split('//')[0] ?? null;
    return AuthService.getInstance().CallBackendFunctionPost('/api/OutsourcedIOBLineItemDetail/Upsert', editedItem);
  }

  static Repeat(editedItem) {
    return AuthService.getInstance().CallBackendFunctionPost('/api/OutsourcedIOBLineItemDetail/Repeat', editedItem);
  }

  static MarkAsUninvoiceable(id) {
    return AuthService.getInstance().CallBackendFunctionPost(
      `/api/OutsourcedIOBLineItemDetail/MarkAsUninvoiceable/${id}`
    );
  }

  static MarkAsInvoiceable(id) {
    return AuthService.getInstance().CallBackendFunctionPost(
      `/api/OutsourcedIOBLineItemDetail/MarkAsInvoiceable/${id}`
    );
  }

  static CollectTimeBasedLineItems() {
    return AuthService.getInstance().CallBackendFunctionPost(
      '/api/OutsourcedIOBLineItemDetail/CollectTimeBasedLineItems'
    );
  }

  static Approve(outsourcedIOBLineItemDetailIds, allItemsSelected, searchItem, newStatus) {
    return AuthService.getInstance().CallBackendFunctionPost('/api/OutsourcedIOBLineItemDetail/Approve', {
      outsourcedIOBLineItemDetailIds,
      allItemsInTheSearchSetAreSelected: allItemsSelected ?? false,
      searchItem: searchItem ?? null,
      newStatus,
    });
  }
}
